import { createContext } from "react";

const SystemBannerContext = createContext<{
	outletRef: HTMLDivElement | null;
	setOutletRef: (ref: HTMLDivElement | null) => void;
	// eslint-disable-next-line @typescript-eslint/no-empty-function
}>({ outletRef: null, setOutletRef: () => {} });

export default SystemBannerContext;
